import { IMPORT_TYPE } from '@bingads-webui-campaign-legacy/scheduled-import/view/import-type';
// import config from '@bingads-webui-component-legacy/config/index';

// TODO: need to add permissions in future
// API Filter
// const permissions = config.get('Permissions');

// const TEST_TYPE_SUFFIX = permissions && permissions.IsUseImportTestTypeForImportTaskExecutionEnabled ? 'Test' : '';

// log api needed
const testTypeSuffix = '';

export const FILTER_IMPORT = `TaskItem/Type eq Enum.TaskItemType'Import${testTypeSuffix}'`;
export const FILTER_MULTIACCOUNT_IMPORT = `TaskItem/Type eq Enum.TaskItemType'MultiAccountGoogleImport${testTypeSuffix}'`;
export const FILTER_FILE_IMPORT = `TaskItem/Type eq Enum.TaskItemType'FileImport${testTypeSuffix}'`;
export const FILTER_FACEBOOK_IMPORT = `TaskItem/Type eq Enum.TaskItemType'FacebookImport${testTypeSuffix}'`;
export const FILTER_AMAZON_IMPORT = `TaskItem/Type eq Enum.TaskItemType'AmazonImport${testTypeSuffix}'`;
export const FILTER_PINTEREST_IMPORT = `TaskItem/Type eq Enum.TaskItemType'PinterestImport${testTypeSuffix}'`;


// schedule api needed
const TEST_TYPE_SUFFIX = '';
const FILTER_OUT_RUNNOW = 'IsRunNow eq false';
const FILTER_IMPORT_TYPE = `Type eq Enum.TaskItemType'Import${TEST_TYPE_SUFFIX}'`;
const FILTER_FACEBOOK_IMPORT_TYPE = `Type eq Enum.TaskItemType'FacebookImport${TEST_TYPE_SUFFIX}'`;
const FILTER_MULTIACCOUNT_IMPORT_TYPE = `Type eq Enum.TaskItemType'MultiAccountGoogleImport${TEST_TYPE_SUFFIX}'`;
const FILTER_AMAZON_IMPORT_TYPE = `Type eq Enum.TaskItemType'AmazonImport${TEST_TYPE_SUFFIX}'`;
const FILTER_PINTEREST_IMPORT_TYPE = `Type eq Enum.TaskItemType'PinterestImport${TEST_TYPE_SUFFIX}'`;

export const FILTER_ALL_ITEMS = `${FILTER_IMPORT_TYPE} and ${FILTER_OUT_RUNNOW}`;
export const FILTER_ALL_BUT_DELETED = `${FILTER_IMPORT_TYPE} and State ne Enum.TaskItemState'Deleted' and ${FILTER_OUT_RUNNOW}`;
export const FILTER_ALL_ITEMS_MULTIACCOUNT = `${FILTER_MULTIACCOUNT_IMPORT_TYPE} and ${FILTER_OUT_RUNNOW}`;
export const FILTER_ALL_BUT_DELETED_MULTIACCOUNT = `${FILTER_MULTIACCOUNT_IMPORT_TYPE} and State ne Enum.TaskItemState'Deleted' and ${FILTER_OUT_RUNNOW}`;

export const FILTER_ALL_FACEBOOK_ITEMS = `${FILTER_FACEBOOK_IMPORT_TYPE} and ${FILTER_OUT_RUNNOW}`;
export const FILTER_ALL_BUT_DELETED_FACEBOOK_ITEMS = `${FILTER_FACEBOOK_IMPORT_TYPE} and State ne Enum.TaskItemState'Deleted' and ${FILTER_OUT_RUNNOW}`;

export const FILTER_ALL_AMAZON_ITEMS = `${FILTER_AMAZON_IMPORT_TYPE} and ${FILTER_OUT_RUNNOW}`;
export const FILTER_ALL_BUT_DELETED_AMAZON_ITEMS = `${FILTER_AMAZON_IMPORT_TYPE} and State ne Enum.TaskItemState'Deleted' and ${FILTER_OUT_RUNNOW}`;

export const FILTER_ALL_PINTEREST_ITEMS = `${FILTER_PINTEREST_IMPORT_TYPE} and ${FILTER_OUT_RUNNOW}`;
export const FILTER_ALL_BUT_DELETED_PINTEREST_ITEMS = `${FILTER_PINTEREST_IMPORT_TYPE} and State ne Enum.TaskItemState'Deleted' and ${FILTER_OUT_RUNNOW}`;

// importChannelType to connection data type
export const IMPORT_CHANNEL_TO_CONNECTION_TYPE = {
  googleimport: 'Google',
  facebookimport: 'Facebook',
  amazonImport: 'Amazon',
  pinterestImport: 'Pinterest',
  fileimport: 'File',
};

// All supported import types api
export const IMPORT_API_TYPE = {
  googleimport: 'googleimport',
  facebookimport: 'facebookimport',
  amazonImport: 'amazonImport',
  pinterestImport: 'pinterestImport',
};

export const CONNECTION_CONTEXT = {
  [IMPORT_API_TYPE.googleimport]: 'AdWordsImportContext',
  [IMPORT_API_TYPE.facebookimport]: 'FacebookImportContext',
  [IMPORT_API_TYPE.amazonImport]: 'AmazonImportContext',
  [IMPORT_API_TYPE.pinterestImport]: 'PinterestImportContext',
};

export const IMPORT_CONNECTION_TYPE_MAP = {
  Import: 'Google',
  FacebookImport: 'Facebook',
  AmazonImport: 'Amazon',
  PinterestImport: 'Pinterest',
};

export const IMPORT_TYPE_ROUTE = {
  [IMPORT_TYPE.googleimport]: '/campaign/vnext/googleimport',
  [IMPORT_TYPE.facebookimport]: '/campaign/vnext/facebookimport',
  [IMPORT_TYPE.fileimport]: '/campaign/vnext/fileimport',
  [IMPORT_TYPE.amazonImport]: '/campaign/vnext/amazonimport',
  [IMPORT_TYPE.pinterestImport]: '/campaign/vnext/pinterestimport',
};
